<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Verify Email Address</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="close()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p class="instruction-text">
      A 6-digit verification code has been sent to
      <strong>{{ data.email }}</strong
      >. Please enter it below.
    </p>

    <div class="otp-wrapper">
      <ng-otp-input
        [config]="otpConfig"
        (onInputChange)="onOtpChange($event)"
        [disabled]="isVerifying"
      ></ng-otp-input>
    </div>

    @if (isVerifying) {
      <div class="status-row">
        <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
        <span>Verifying…</span>
      </div>
    }

    @if (errorMessage) {
      <mat-error class="error-message">{{ errorMessage }}</mat-error>
    }

    @if (resendSuccess) {
      <p class="resend-success">
        A new code has been sent to {{ data.email }}.
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <span class="resend-label">Didn't receive a code?</span>
    <button
      mat-button
      color="primary"
      [disabled]="isResending || isVerifying"
      (click)="resendCode()"
    >
      @if (isResending) {
        <mat-spinner
          diameter="16"
          strokeWidth="2"
          class="inline-spinner"
        ></mat-spinner>
      }
      Resend Code
    </button>
    <button mat-button (click)="close()">Cancel</button>
  </mat-dialog-actions>
</div>
